import {newElementId} from './utils/newid'

/* eslint-disable global-require */
export const GridCount = 2;
export const findFieldById = (elementId, fields) => {

    let col = false;
    // row = fields.
    const row = fields.findIndex(e => {
        col = e.findIndex(f => {

            return f.elementId === elementId
        });
        if (col !== -1) {
            return true;
        }
        return false;
    });

    return {field: (fields.length && row !== -1) ? fields[row][col] : false, row, col}


}

const taxClass_list = [...Object.keys(window.awcfe_object.taxClass_list).map((key) => {
    return {value: window.awcfe_object.taxClass_list[key], label: window.awcfe_object.taxClass_list[key]};
})];

export const tabLabels = {
    general: {label: wp.i18n.__('General'), icon: require('./icons/settings.svg')},
    advanced: {label: wp.i18n.__('Advanced'), icon: require('./icons/sliders.svg')},
    clLogic: {label: wp.i18n.__('Conditional'), icon: require('./icons/cllogic.svg')},
    pricing: {label: wp.i18n.__('Pricing'), icon: require('./icons/pricing.svg')},
}

export const actionIcons = {
    edit: {label: wp.i18n.__('Edit'), icon: require('./icons/edit.svg')},
    copy: {label: wp.i18n.__('Copy'), icon: require('./icons/copy.svg')},
    delete: {label: wp.i18n.__('Delete'), icon: require('./icons/delete.svg')},
    actioncopy: {label: wp.i18n.__('Copy'), icon: require('./icons/action_copy.svg')},
    actionremove: {label: wp.i18n.__('Remove'), icon: require('./icons/action_remove.svg')},
    trash: {label: wp.i18n.__('Remove'), icon: require('./icons/trash.svg')}
}

export const createSection = () => {

    return [
        {
            item: 'name', group: 'general',
            render: {
                'type': 'text',
                'class': 'class_name'
            },
            label: {
                'first': wp.i18n.__('Section Name')
            }
        },
        {
            item: 'section_id', group: 'general', render: 'elementId',
            label: {
                'first': wp.i18n.__('Section ID')
            }
        },
        {
            item: 'enableSec', group: 'general', render: 'toggle',
            label: {
                'first': wp.i18n.__('Enable/Disable'),
            },
        },
        {
            item: 'sec_Position',
            group: 'general',
            render: 'select',
            label: wp.i18n.__("Position"),
            options: [
                {value: 'woocommerce_checkout_before_customer_details', label: wp.i18n.__('Before customer details')},
                {value: 'woocommerce_checkout_after_customer_details', label: wp.i18n.__('After customer details')},
                {value: 'woocommerce_before_checkout_billing_form', label: wp.i18n.__('Before checkout billing form')},
                {value: 'woocommerce_after_checkout_billing_form', label: wp.i18n.__('After checkout billing form')},
                {value: 'woocommerce_before_checkout_shipping_form', label: wp.i18n.__('Before checkout shipping form')},
                {value: 'woocommerce_after_checkout_shipping_form', label: wp.i18n.__('After checkout shipping form')},
                // {value: 'woocommerce_before_checkout_registration_form', label: 'Before checkout registration form'},
                // {value: 'woocommerce_after_checkout_registration_form', label: 'After checkout registration form'},
                {value: 'woocommerce_before_order_notes', label: wp.i18n.__('Before order notes')},
                {value: 'woocommerce_after_order_notes', label: wp.i18n.__('After order notes')},

                {value: 'woocommerce_checkout_before_terms_and_conditions', label: 'Before terms & conditions'},
                {value: 'woocommerce_checkout_after_terms_and_conditions', label: 'After terms & conditions'},
                {value: 'woocommerce_review_order_before_payment', label: wp.i18n.__('Before payment method')},
                {value: 'woocommerce_review_order_before_submit', label: 'Before submit button'},
                {value: 'woocommerce_review_order_after_submit', label: wp.i18n.__('After submit button')},



            ],

        },
        {
            item: 'sec_Order', group: 'general', render: {
                'type': 'number',
            },
            label: {
                'first': wp.i18n.__('Order')
            },
            min: 1,
        },
        {
            item: 'sec_Class', group: 'advanced', render: {
                'type': 'text',
            },
            label: {
                'first': wp.i18n.__('Class Name')
            }
        },

        {
            item: 'enableCl',
            group: 'clLogic',
            render: 'toggle',
            label: {first: wp.i18n.__('Enable Conditional Logic'), second: wp.i18n.__('')},
            order: 99
        },
        {
            item: 'relations',
            group: 'clLogic',
            render: 'conditional_logic',
            label: wp.i18n.__("enableCl"),
            order: 99
        },

    ]
}


export const createSectionDefault = () => {

    return [
        {
            item: 'name', group: 'general',
            render: {
                'type': 'text',
                'class': 'class_name'
            },
            label: {
                'first': wp.i18n.__('Section Name')
            }
        },
    ]
}

export const defaultFieldAttrs = type => {
    const defaultAttrs =
        [
            {
                item: 'label',
                group: 'general',
                render: 'text',
                label: {first: wp.i18n.__('Field Label')},
                isMlEditable: true

            },
            {item: 'active', group: 'general', render: 'toggle',
                label: wp.i18n.__("Enable/Disable Field")
            },

            {
                item: 'placeholder',
                group: 'general',
                render: 'text',
                label: {first: wp.i18n.__('Field Placeholder')},
                isMlEditable: true
            },
            {
                item: 'required',
                group: 'general',
                render: 'toggle',
                label: {first: wp.i18n.__('Is Required')}
            },
            {
                item: 'name',
                group: 'general',
                render: 'text',
                label: {first: wp.i18n.__('Field Name'), second: wp.i18n.__('* Name must be unique')},
                validation: [{
                    type: "required",
                }]
            },
            {
                item: 'default',
                group: 'general',
                render: 'text',
                label: {first: wp.i18n.__('Field Default Value')},
                isMlEditable: true
            },
            {
                item: 'description',
                group: 'general',
                render: 'text',
                label: {first: 'Field Description'},
                isMlEditable: true
            },
            {
                item: 'elementId',
                group: 'general',
                render: 'elementId',
                label: {first: wp.i18n.__('Element ID'), second: wp.i18n.__('Unique ID for the field')},
                validation: [{
                    type: "required",
                }]
            },

            {
                item: 'custom_class',
                group: 'advanced',
                render: 'text',
                label: wp.i18n.__("Custom Class Name"),
                order: 99,
                isMlEditable: true,
            },
            {
                item: 'show_in_email',
                group: 'advanced',
                render: 'toggle',
                label: wp.i18n.__("Show this Field in Order Email?"),
                order: 99
            },
            {
                item: 'show_in_order_page',
                group: 'advanced',
                render: 'toggle',
                label: wp.i18n.__("Show this Field in Order Detail Page?"),
                order: 99
            },

            {
                item: 'enableCl',
                group: 'clLogic',
                render: 'toggle',
                label: {first: wp.i18n.__('Enable Conditional Logic'), second: wp.i18n.__('')},
                order: 99
            },
            {
                item: 'relations',
                group: 'clLogic',
                render: 'conditional_logic',
                label: wp.i18n.__("enableCl"),
                order: 99
            },
            {
                item: 'enablePrice',
                group: 'pricing',
                render: 'toggle',
                label: {first: wp.i18n.__('Enable Pricing'), second: wp.i18n.__('')},
                order: 97
            },
            // {
            //     item: 'pricingType',
            //     group: 'pricing',
            //     render: { type: "select" },
            //     options: [
            //         {value: 'fixed', label: wp.i18n.__('Fixed')},
            //         {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
            //         {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
            //         {value: 'custom', label: wp.i18n.__('Custom Formula')},
            //     ],
            //     order: 99,
            //     label: wp.i18n.__("Pricing Type"),
            //     conditions: [
            //         {
            //             type: "field",
            //             field: "enablePrice",
            //             value: true
            //         }
            //     ]
            //
            // },
            {
                item: 'price',
                group: 'pricing',
                render: 'price',
                label: wp.i18n.__("Price"),
                order: 99,
                conditions: [
                    {
                        type: "field",
                        field: "enablePrice",
                        value: true
                    },
                    {
                        type: "field",
                        field: "pricingType",
                        value: 'fixed'
                    }
                ]
            },
            {
                item: 'price',
                group: 'pricing',
                render: 'price',
                label: {first: wp.i18n.__("Percentage")},
                order: 99,
                conditions: [
                    {
                        type: "field",
                        field: "enablePrice",
                        value: true
                    },
                    {
                        type: "field",
                        field: "pricingType",
                        value: 'percentage_content_total'
                    }
                ]
            },
            {
                item: 'price',
                group: 'pricing',
                render: 'price',
                label: {first: wp.i18n.__("Percentage")},
                order: 99,
                conditions: [
                    {
                        type: "field",
                        field: "enablePrice",
                        value: true
                    },
                    {
                        type: "field",
                        field: "pricingType",
                        value: 'percentage_subtotal'
                    }
                ]
            },
            {
                item: 'price',
                group: 'pricing',
                render: 'price',
                label: {first: wp.i18n.__("Percentage")},
                order: 99,
                conditions: [
                    {
                        type: "field",
                        field: "enablePrice",
                        value: true
                    },
                    {
                        type: "field",
                        field: "pricingType",
                        value: 'percentage_subtotal_extax'
                    }
                ]
            },
            {
               item: 'price',
               group: 'pricing',
               render: 'price',
               label: {
                   first: wp.i18n.__("Custom Formula"),
                   second: wp.i18n.__("eg: ({value}*2.5) for multiply a number to entered value, or {value} for an amount entered. Here value will be the value entered by customer")
               },
               order: 99,
               conditions: [
                   {
                       type: "field",
                       field: "enablePrice",
                       value: true
                   },
                   {
                       type: "field",
                       field: "pricingType",
                       value: 'custom'
                   }
               ]
           },
            {
               item: 'price_label',
               group: 'pricing',
               render: 'text',
               label: {
                   first: wp.i18n.__("Price label"),
                   second: wp.i18n.__("")
               },
               order: 99,
               isMlEditable: true,
               conditions: [
                   {
                       type: "field",
                       field: "enablePrice",
                       value: true
                   },
               ]
           },
           {
               item: 'enableTax',
               group: 'pricing',
               render: 'toggle',
               label: {first: wp.i18n.__('Enable Tax'), second: wp.i18n.__('')},
               order: 99,
               conditions: [
                   {
                       type: "field",
                       field: "enablePrice",
                       value: true
                   },
               ]
           },
           {
               item: 'price_taxClass',
               group: 'pricing',
               render: { type: "select" },
               options: taxClass_list,
               label: {first: wp.i18n.__("Tax class")},
               order: 99,
               conditions: [
                   {
                       type: "field",
                       field: "enablePrice",
                       value: true
                   },
                   {
                       type: "field",
                       field: "enableTax",
                       value: true
                   }
               ]
           },

        ]


    const typeAttrsMap = {

        text: defaultAttrs.concat(
            [
                // {item: 'disable_manual_input', group: 'general', render: 'text'},
                {
                    item: 'pricingType',
                    group: 'pricing',
                    render: { type: "select" },
                    options: [
                        {value: 'fixed', label: wp.i18n.__('Fixed')},
                        {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
                        {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
                        {value: 'percentage_subtotal_extax', label: wp.i18n.__('Percentage of Cart subtotal Excluding Tax')},
                        {value: 'custom', label: wp.i18n.__('Custom Formula')},
                    ],
                    order: 98,
                    label: wp.i18n.__("Pricing Type"),
                    conditions: [
                        {
                            type: "field",
                            field: "enablePrice",
                            value: true
                        }
                    ]

                },

                {
                    item: 'disable_manual_input',
                    group: 'general',
                    render: 'toggle',
                    label: {first: wp.i18n.__('Read-only')}
                },
                {
                    item: 'subtype',
                    group: 'general',
                    render: 'select',
                    label: wp.i18n.__("Select Type"),
                    options: [
                        {value: 'text', label: wp.i18n.__('Text')},
                        {value: 'hidden', label: wp.i18n.__('Hidden')},
                        {value: 'email', label: wp.i18n.__('Email')},
                        {value: 'password', label: wp.i18n.__('Password')},
                        {value: 'tel', label: wp.i18n.__('Phone')},
                    ]
                },
                {
                    item: 'allowed_char_regex',
                    group: 'advanced',
                    render: 'text',
                    label: {first: wp.i18n.__('Allowed Characters(Regex)'), second: wp.i18n.__('Use regular expression')},
                    isMlEditable: true,
                },
                {
                    item: 'allowed_char_errmsg',
                    group: 'advanced',
                    render: 'text',
                    label: {first: wp.i18n.__('Error message'), second: wp.i18n.__('Only for Allowed Characters validation')},
                    isMlEditable: true,
                },
                {item: 'maxlength', group: 'advanced', render: 'number', label: wp.i18n.__('Max Length'),
                isMlEditable: true},
            ]),

        url: defaultAttrs.concat([
          // { item: 'disable_manual_input', group: 'general', render: 'toggle', label: {first: wp.i18n.__('Read-only')} },
          {
              item: 'pricingType',
              group: 'pricing',
              render: { type: "select" },
              options: [
                  {value: 'fixed', label: wp.i18n.__('Fixed')},
                  {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
                  {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
                  {value: 'percentage_subtotal_extax', label: wp.i18n.__('Percentage of Cart subtotal Excluding Tax')},
              ],
              order: 98,
              label: wp.i18n.__("Pricing Type"),
              conditions: [
                  {
                      type: "field",
                      field: "enablePrice",
                      value: true
                  }
              ]

          },

        ]),

        header:
            [
                {
                    item: 'label',
                    group: 'general',
                    render: 'text',
                    label: {first: wp.i18n.__('Field Label')},
                    isMlEditable: true

                },
                {item: 'active', group: 'general', render: 'toggle', label: wp.i18n.__("Enable/Disable Field")},
                {
                    item: 'elementId',
                    group: 'general',
                    render: 'elementId',
                    label: {first: wp.i18n.__('Element ID'), second: wp.i18n.__('Unique ID for the field')},
                    validation: [{
                        type: "required",
                    }]
                },

                {item: 'custom_class', group: 'advanced', render: 'text', label: wp.i18n.__("Custom Class Name"),
                isMlEditable: true},
                {
                    item: 'subtype',
                    group: 'general',
                    render: 'select',
                    label: wp.i18n.__("Select Type"),
                    options: [
                        {value: 'h1', label: 'H1'},
                        {value: 'h2', label: 'H2'},
                        {value: 'h3', label: 'H3'},
                        {value: 'h4', label: 'H4'},
                        {value: 'h5', label: 'H5'},
                        {value: 'h6', label: 'H6'},
                    ]
                },
                {
                    item: 'show_in_email',
                    group: 'advanced',
                    render: 'toggle',
                    label: wp.i18n.__("Show this Field in Order Email?"),
                    order: 99
                },
                {
                    item: 'show_in_order_page',
                    group: 'advanced',
                    render: 'toggle',
                    label: wp.i18n.__("Show this Field in Order Detail Page?"),
                    order: 99
                },
                {
                    item: 'enableCl',
                    group: 'clLogic',
                    render: 'toggle',
                    label: {first: wp.i18n.__('Enable Conditional Logic'), second: wp.i18n.__('')},
                    order: 99
                },
                {
                    item: 'relations',
                    group: 'clLogic',
                    render: 'conditional_logic',
                    label: wp.i18n.__("enableCl"),
                    order: 99
                },
                
            ],
        // hidden: ['label', 'elementId', 'name', 'value'],
        paragraph:
            [
                {
                    item: 'label',
                    group: 'general',
                    render: 'textarea',
                    label: {first: wp.i18n.__('Field Label')},
                    isMlEditable: true

                },
                {item: 'active', group: 'general', render: 'toggle', label: wp.i18n.__("Enable/Disable Field")},
                {
                    item: 'elementId',
                    group: 'general',
                    render: 'elementId',
                    label: {first: 'Element ID', second: wp.i18n.__('Unique ID for the field')},
                    validation: [{
                        type: "required",
                    }]
                },

                {item: 'custom_class', group: 'advanced', render: 'text', label: wp.i18n.__("Custom Class Name"),
                isMlEditable: true},
                {
                    item: 'subtype',
                    group: 'general',
                    render: 'select',
                    label: wp.i18n.__("Select Type"),
                    options: [
                        {value: 'p', label: 'Paragraph'},
                        {value: 'label', label: 'Label'},
                        {value: 'span', label: 'Span'},
                        {value: 'div', label: 'Div'},
                    ]
                },
                {
                    item: 'show_in_email',
                    group: 'advanced',
                    render: 'toggle',
                    label: wp.i18n.__("Show this Field in Order Email?"),
                    order: 99
                },
                {
                    item: 'show_in_order_page',
                    group: 'advanced',
                    render: 'toggle',
                    label: wp.i18n.__("Show this Field in Order Detail Page?"),
                    order: 99
                },
                {
                    item: 'enableCl',
                    group: 'clLogic',
                    render: 'toggle',
                    label: {first: wp.i18n.__('Enable Conditional Logic'), second: wp.i18n.__('')},
                    order: 99
                },
                {
                    item: 'relations',
                    group: 'clLogic',
                    render: 'conditional_logic',
                    label: wp.i18n.__("enableCl"),
                    order: 99
                },

            ],

            htmlf:
                [
                    {
                        item: 'label',
                        group: 'general',
                        render: 'text',
                        label: {first: wp.i18n.__('Field Label')},
                        isMlEditable: true
        
                    },
                    {item: 'active', group: 'general', render: 'toggle',
                        label: wp.i18n.__("Enable/Disable Field")
                    },
                    {
                        item: 'value',
                        group: 'general',
                        render: 'textarea',
                        label: {first: wp.i18n.__('Field Value')},
                        isMlEditable: true,
                        validation: [{
                            type: "required",
                        }]
                    },
                    {
                        item: 'name',
                        group: 'general',
                        render: 'text',
                        label: {first: wp.i18n.__('Field Name'), second: wp.i18n.__('* Name must be unique')},
                        validation: [{
                            type: "required",
                        }]
                    },
                    {
                        item: 'elementId',
                        group: 'general',
                        render: 'elementId',
                        label: {first: 'Element ID', second: wp.i18n.__('Unique ID for the field')},
                        validation: [{
                            type: "required",
                        }]
                    },
                    {item: 'custom_class', group: 'advanced', render: 'text', label: wp.i18n.__("Custom Class Name"),
                    isMlEditable: true},
                    {
                        item: 'show_in_email',
                        group: 'advanced',
                        render: 'toggle',
                        label: wp.i18n.__("Show this Field in Order Email?"),
                        order: 99
                    },
                    {
                        item: 'show_in_order_page',
                        group: 'advanced',
                        render: 'toggle',
                        label: wp.i18n.__("Show this Field in Order Detail Page?"),
                        order: 99
                    },
                    {
                        item: 'enableCl',
                        group: 'clLogic',
                        render: 'toggle',
                        label: {first: wp.i18n.__('Enable Conditional Logic'), second: wp.i18n.__('')},
                        order: 99
                    },
                    {
                        item: 'relations',
                        group: 'clLogic',
                        render: 'conditional_logic',
                        label: wp.i18n.__("enableCl"),
                        order: 99
                    },
    
                ],
        // separator: ['className', 'elementId', 'height', 'enableCl'],
        // number: defaultAttrs.concat(['disable_manual_input', 'min', 'max', 'step']),
        numberfield: defaultAttrs.concat([
          {
              item: 'pricingType',
              group: 'pricing',
              render: { type: "select" },
              options: [
                  {value: 'fixed', label: wp.i18n.__('Fixed')},
                  {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
                  {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
                  {value: 'percentage_subtotal_extax', label: wp.i18n.__('Percentage of Cart subtotal Excluding Tax')},
                  {value: 'custom', label: wp.i18n.__('Custom Formula')},
              ],
              order: 98,
              label: wp.i18n.__("Pricing Type"),
              conditions: [
                  {
                      type: "field",
                      field: "enablePrice",
                      value: true
                  }
              ]

          },
            {
                item: 'disable_manual_input',
                group: 'general',
                render: 'toggle',
                label: {first: wp.i18n.__('Read-only')}
            },
            {item: 'min', group: 'general', render: 'number', label: wp.i18n.__('Minimum value')},
            {item: 'max', group: 'general', render: 'number', label: wp.i18n.__('Maximum value')},
            {item: 'step', group: 'general', render: 'number', label: wp.i18n.__('Step value')},
            // {item: 'maxlength', group: 'advanced', render: 'number', label: wp.i18n.__('Max Length')},
        ]),
        colorpicker: defaultAttrs.concat([
          {
              item: 'pricingType',
              group: 'pricing',
              render: { type: "select" },
              options: [
                  {value: 'fixed', label: wp.i18n.__('Fixed')},
                  {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
                  {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
                  {value: 'percentage_subtotal_extax', label: wp.i18n.__('Percentage of Cart subtotal Excluding Tax')},
                  //{value: 'custom', label: wp.i18n.__('Custom Formula')},
              ],
              order: 98,
              label: wp.i18n.__("Pricing Type"),
              conditions: [
                  {
                      type: "field",
                      field: "enablePrice",
                      value: true
                  }
              ]

          },
            // {item: 'step', group: 'general', render: 'number', label: wp.i18n.__('Step value')},
        ]),
        select: defaultAttrs.concat(
            [
                {
                    item: 'priceOptions',
                    group: 'pricing',
                    render: { type: "select", },
                    options: [
                        {value: 'different_for_all', label: wp.i18n.__('Different Price for each options')},
                        {value: 'fixed_for_all', label: wp.i18n.__('Same for all Options')},

                    ],
                    label: wp.i18n.__("Pricing Options"),
                    order: 98,
                    conditions: [
                        {
                            type: "field",
                            field: "enablePrice",
                            value: true
                        }
                    ]

                },
                {
                    item: 'pricingType',
                    group: 'pricing',
                    render: { type: "select" },
                    options: [
                        {value: 'fixed', label: wp.i18n.__('Fixed')},
                        {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
                        {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
                        {value: 'percentage_subtotal_extax', label: wp.i18n.__('Percentage of Cart subtotal Excluding Tax')},
                        //{value: 'custom', label: wp.i18n.__('Custom Formula')},
                    ],
                    order: 98,
                    label: wp.i18n.__("Pricing Type"),
                    conditions: [
                        {
                            type: "field",
                            field: "enablePrice",
                            value: true
                        }
                    ]

                },
                {
                    item: 'wpml_sync',
                    group: 'general',
                    render: {
                        type: 'toggle',

                    },
                    label: {first: wp.i18n.__("Sync Options With Base Language?"), second: ''},
                    isMlEditable: true,
                    conditions: [
                        {
                            type: "defaultLang",
                            value: false
                        }
                    ]
                },
                {
                item: 'options',
                group: 'general',
                render: {
                    type: 'options'
                },
                label: {first: wp.i18n.__("Field Options"), second: '4'},
                isMlEditable: true

            },
            ]),
        multiselect: defaultAttrs.concat(
            [
                {
                    item: 'priceOptions',
                    group: 'pricing',
                    render: { type: "select", },
                    options: [
                        {value: 'different_for_all', label: wp.i18n.__('Different Price for each options')},
                        {value: 'fixed_for_all', label: wp.i18n.__('Same for all Options')},

                    ],
                    label: wp.i18n.__("Pricing Options"),
                    order: 98,
                    conditions: [
                        {
                            type: "field",
                            field: "enablePrice",
                            value: true
                        }
                    ]

                },
                {
                    item: 'pricingType',
                    group: 'pricing',
                    render: { type: "select" },
                    options: [
                        {value: 'fixed', label: wp.i18n.__('Fixed')},
                        {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
                        {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
                        {value: 'percentage_subtotal_extax', label: wp.i18n.__('Percentage of Cart subtotal Excluding Tax')},
                        //{value: 'custom', label: wp.i18n.__('Custom Formula')},
                    ],
                    order: 98,
                    label: wp.i18n.__("Pricing Type"),
                    conditions: [
                        {
                            type: "field",
                            field: "enablePrice",
                            value: true
                        }
                    ]

                },
                {
                    item: 'wpml_sync',
                    group: 'general',
                    render: {
                        type: 'toggle',

                    },
                    label: {first: wp.i18n.__("Sync Options With Base Language?"), second: ''},
                    isMlEditable: true,
                    conditions: [
                        {
                            type: "defaultLang",
                            value: false
                        }
                    ]
                }, {
                item: 'options',
                group: 'general',
                render: {
                    type: 'options'
                },
                label: {first: wp.i18n.__("Field Options"), second: '4'},
                isMlEditable: true

            },
            ]),
        checkboxGroup: defaultAttrs.concat(
            [
              {
                  item: 'makeinline',
                  group: 'general',
                  render: {
                      type: 'toggle',

                  },
                  label: {first: wp.i18n.__("Display Inline"), second: ''},
                  isMlEditable: true,
                  order: 98,
              },
                  {
                      item: 'priceOptions',
                      group: 'pricing',
                      render: { type: "select", },
                      options: [
                          {value: 'different_for_all', label: wp.i18n.__('Different Price for each options')},
                          {value: 'fixed_for_all', label: wp.i18n.__('Same for all Options')},

                      ],
                      label: wp.i18n.__("Pricing Options"),
                      order: 98,
                      conditions: [
                          {
                              type: "field",
                              field: "enablePrice",
                              value: true
                          }
                      ]

                  },
                  {
                      item: 'pricingType',
                      group: 'pricing',
                      render: { type: "select" },
                      options: [
                          {value: 'fixed', label: wp.i18n.__('Fixed')},
                          {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
                          {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
                          {value: 'percentage_subtotal_extax', label: wp.i18n.__('Percentage of Cart subtotal Excluding Tax')},
                          //{value: 'custom', label: wp.i18n.__('Custom Formula')},
                      ],
                      order: 98,
                      label: wp.i18n.__("Pricing Type"),
                      conditions: [
                          {
                              type: "field",
                              field: "enablePrice",
                              value: true
                          }
                      ]

                  },
              {
                item: 'wpml_sync',
                group: 'general',
                render: {
                    type: 'toggle'

                },
                label: {first: wp.i18n.__("Sync Options With Base Language?"), second: ''},
                conditions: [
                    {
                        type: "defaultLang",
                        value: false
                    }
                ],
                isMlEditable: true
            },
                {
                    item: 'options',
                    group: 'general',
                    render: {
                        type: 'options'
                    },
                    label: wp.i18n.__("Options"),
                    isMlEditable: true
                },

            ]),
            checkbox:
                [
                    {
                        item: 'label',
                        group: 'general',
                        render: 'text',
                        label: {first: wp.i18n.__('Field Label')},
                        isMlEditable: true

                    },
                    {item: 'active', group: 'general', render: 'toggle', label: wp.i18n.__("Enable/Disable Field")},
                    {
                        item: 'default',
                        group: 'general',
                        render: 'text',
                        label: {first: wp.i18n.__('Field Value')},
                        isMlEditable: true,
                        validation: [{
                            type: "required",
                        }]
                    },
                    { item: 'required', group: 'general', render: 'toggle', label: {first: wp.i18n.__('Is Required')} },
                    {
                        item: 'description',
                        group: 'general',
                        render: 'text',
                        label: {first: 'Field Description'},
                        isMlEditable: true
                    },
                    {
                        item: 'is_checked',
                        group: 'general',
                        render: 'toggle',
                        label: {first: wp.i18n.__('Checked by default')}
                    },
                    {
                        item: 'name',
                        group: 'general',
                        render: 'text',
                        label: {first: wp.i18n.__('Field Name'), second: wp.i18n.__('* Name must be unique')},
                        validation: [{
                            type: "required",
                        }]
                    },
                    {
                        item: 'elementId',
                        group: 'general',
                        render: 'elementId',
                        label: {first: 'Element ID', second: wp.i18n.__('Unique ID for the field')},
                        validation: [{
                            type: "required",
                        }]
                    },

                    {item: 'custom_class', group: 'advanced', render: 'text', label: wp.i18n.__("Custom Class Name"),
                    isMlEditable: true},
                    {
                        item: 'show_in_email',
                        group: 'advanced',
                        render: 'toggle',
                        label: wp.i18n.__("Show this Field in Order Email?"),
                        order: 99
                    },
                    {
                        item: 'show_in_order_page',
                        group: 'advanced',
                        render: 'toggle',
                        label: wp.i18n.__("Show this Field in Order Detail Page?"),
                        order: 99
                    },
                    {
                        item: 'enableCl',
                        group: 'clLogic',
                        render: 'toggle',
                        label: {first: wp.i18n.__('Enable Conditional Logic'), second: wp.i18n.__('')},
                        order: 99
                    },
                    {
                        item: 'relations',
                        group: 'clLogic',
                        render: 'conditional_logic',
                        label: wp.i18n.__("enableCl"),
                        order: 99
                    },
                    {
                        item: 'enablePrice',
                        group: 'pricing',
                        render: 'toggle',
                        label: {first: wp.i18n.__('Enable Pricing'), second: wp.i18n.__('')},
                        order: 97
                    },
                    {
                        item: 'pricingType',
                        group: 'pricing',
                        render: { type: "select" },
                        options: [
                            {value: 'fixed', label: wp.i18n.__('Fixed')},
                            {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
                            {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
                            {value: 'percentage_subtotal_extax', label: wp.i18n.__('Percentage of Cart subtotal Excluding Tax')},
                            // {value: 'custom', label: wp.i18n.__('Custom Formula')},
                        ],
                        order: 98,
                        label: wp.i18n.__("Pricing Type"),
                        conditions: [
                            {
                                type: "field",
                                field: "enablePrice",
                                value: true
                            }
                        ]

                    },
                    {
                       item: 'price',
                       group: 'pricing',
                       render: 'price',
                       label: wp.i18n.__("Price"),
                       order: 99,
                       conditions: [
                           {
                               type: "field",
                               field: "enablePrice",
                               value: true
                           },
                           {
                               type: "field",
                               field: "pricingType",
                               value: 'fixed'
                           }
                       ]
                   },
                   {
                       item: 'price',
                       group: 'pricing',
                       render: 'price',
                       label: {first: wp.i18n.__("Percentage")},
                       order: 99,
                       conditions: [
                           {
                               type: "field",
                               field: "enablePrice",
                               value: true
                           },
                           {
                               type: "field",
                               field: "pricingType",
                               value: 'percentage_content_total'
                           }
                       ]
                   },
                   {
                       item: 'price',
                       group: 'pricing',
                       render: 'price',
                       label: {first: wp.i18n.__("Percentage")},
                       order: 99,
                       conditions: [
                           {
                               type: "field",
                               field: "enablePrice",
                               value: true
                           },
                           {
                               type: "field",
                               field: "pricingType",
                               value: 'percentage_subtotal'
                           }
                       ]
                   },
                   {
                       item: 'price',
                       group: 'pricing',
                       render: 'price',
                       label: {first: wp.i18n.__("Percentage")},
                       order: 99,
                       conditions: [
                           {
                               type: "field",
                               field: "enablePrice",
                               value: true
                           },
                           {
                               type: "field",
                               field: "pricingType",
                               value: 'percentage_subtotal_extax'
                           }
                       ]
                   },
                   {
                      item: 'price',
                      group: 'pricing',
                      render: 'price',
                      label: {
                          first: wp.i18n.__("Custom Formula"),
                          second: wp.i18n.__("eg: ({value}*2.5) for multiply a number to entered value, or {value} for an amount entered. Here value will be the value entered by customer")
                      },
                      order: 99,
                      conditions: [
                          {
                              type: "field",
                              field: "enablePrice",
                              value: true
                          },
                          {
                              type: "field",
                              field: "pricingType",
                              value: 'custom'
                          }
                      ]
                  },
                   {
                      item: 'price_label',
                      group: 'pricing',
                      render: 'text',
                      label: {
                          first: wp.i18n.__("Price label"),
                          second: wp.i18n.__("")
                      },
                      order: 99,
                      isMlEditable: true,
                      conditions: [
                          {
                              type: "field",
                              field: "enablePrice",
                              value: true
                          },
                      ]
                  },
                  {
                      item: 'enableTax',
                      group: 'pricing',
                      render: 'toggle',
                      label: {first: wp.i18n.__('Enable Tax'), second: wp.i18n.__('')},
                      order: 99,
                      conditions: [
                          {
                              type: "field",
                              field: "enablePrice",
                              value: true
                          },
                      ]
                  },
                  {
                      item: 'price_taxClass',
                      group: 'pricing',
                      render: { type: "select" },
                      options: taxClass_list,
                      label: {first: wp.i18n.__("Tax class")},
                      order: 99,
                      conditions: [
                          {
                              type: "field",
                              field: "enablePrice",
                              value: true
                          },
                          {
                              type: "field",
                              field: "enableTax",
                              value: true
                          }
                      ]
                  },

                ],

                toggleSwitch:
                    [
                        {
                            item: 'label',
                            group: 'general',
                            render: 'text',
                            label: {first: wp.i18n.__('Field Label')},
                            isMlEditable: true

                        },
                        {item: 'active', group: 'general', render: 'toggle', label: wp.i18n.__("Enable/Disable Field")},
                        { item: 'default', group: 'general', render: 'text', label: {first: wp.i18n.__('Field Value')}, isMlEditable: true },
                        { item: 'required', group: 'general', render: 'toggle', label: {first: wp.i18n.__('Is Required')} },
                        { item: 'is_checked', group: 'general', render: 'toggle', label: {first: wp.i18n.__('Checked by default')} },
                        {
                            item: 'name',
                            group: 'general',
                            render: 'text',
                            label: {first: wp.i18n.__('Field Name'), second: wp.i18n.__('* Name must be unique')},
                            validation: [{
                                type: "required",
                            }]
                        },
                        {
                            item: 'elementId',
                            group: 'general',
                            render: 'elementId',
                            label: {first: 'Element ID', second: wp.i18n.__('Unique ID for the field')},
                            validation: [{
                                type: "required",
                            }]
                        },
                        {
                            item: 'description',
                            group: 'general',
                            render: 'text',
                            label: {first: 'Field Description'},
                            isMlEditable: true
                        },
                        { item: 'makeinline', group: 'general', render: { type: 'toggle', }, label: {first: wp.i18n.__("Display Inline"), second: ''}, isMlEditable: true, order: 98, },
                        {item: 'custom_class', group: 'advanced', render: 'text', label: wp.i18n.__("Custom Class Name"),
                        isMlEditable: true},
                        {
                            item: 'show_in_email',
                            group: 'advanced',
                            render: 'toggle',
                            label: wp.i18n.__("Show this Field in Order Email?"),
                            order: 99
                        },
                        {
                            item: 'show_in_order_page',
                            group: 'advanced',
                            render: 'toggle',
                            label: wp.i18n.__("Show this Field in Order Detail Page?"),
                            order: 99
                        },
                        {
                            item: 'enableCl',
                            group: 'clLogic',
                            render: 'toggle',
                            label: {first: wp.i18n.__('Enable Conditional Logic'), second: wp.i18n.__('')},
                            order: 99
                        },
                        {
                            item: 'relations',
                            group: 'clLogic',
                            render: 'conditional_logic',
                            label: wp.i18n.__("enableCl"),
                            order: 99
                        },
                        {
                            item: 'enablePrice',
                            group: 'pricing',
                            render: 'toggle',
                            label: {first: wp.i18n.__('Enable Pricing'), second: wp.i18n.__('')},
                            order: 97
                        },
                        {
                            item: 'pricingType',
                            group: 'pricing',
                            render: { type: "select" },
                            options: [
                                {value: 'fixed', label: wp.i18n.__('Fixed')},
                                {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
                                {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
                                {value: 'percentage_subtotal_extax', label: wp.i18n.__('Percentage of Cart subtotal Excluding Tax')},
                                // {value: 'custom', label: wp.i18n.__('Custom Formula')},
                            ],
                            order: 98,
                            label: wp.i18n.__("Pricing Type"),
                            conditions: [
                                {
                                    type: "field",
                                    field: "enablePrice",
                                    value: true
                                }
                            ]

                        },
                        {
                           item: 'price',
                           group: 'pricing',
                           render: 'price',
                           label: wp.i18n.__("Price"),
                           order: 99,
                           conditions: [
                               {
                                   type: "field",
                                   field: "enablePrice",
                                   value: true
                               },
                               {
                                   type: "field",
                                   field: "pricingType",
                                   value: 'fixed'
                               }
                           ]
                       },
                       {
                           item: 'price',
                           group: 'pricing',
                           render: 'price',
                           label: {first: wp.i18n.__("Percentage")},
                           order: 99,
                           conditions: [
                               {
                                   type: "field",
                                   field: "enablePrice",
                                   value: true
                               },
                               {
                                   type: "field",
                                   field: "pricingType",
                                   value: 'percentage_content_total'
                               }
                           ]
                       },
                       {
                           item: 'price',
                           group: 'pricing',
                           render: 'price',
                           label: {first: wp.i18n.__("Percentage")},
                           order: 99,
                           conditions: [
                               {
                                   type: "field",
                                   field: "enablePrice",
                                   value: true
                               },
                               {
                                   type: "field",
                                   field: "pricingType",
                                   value: 'percentage_subtotal'
                               }
                           ]
                       },
                       {
                           item: 'price',
                           group: 'pricing',
                           render: 'price',
                           label: {first: wp.i18n.__("Percentage")},
                           order: 99,
                           conditions: [
                               {
                                   type: "field",
                                   field: "enablePrice",
                                   value: true
                               },
                               {
                                   type: "field",
                                   field: "pricingType",
                                   value: 'percentage_subtotal_extax'
                               }
                           ]
                       },
                       {
                          item: 'price',
                          group: 'pricing',
                          render: 'price',
                          label: {
                              first: wp.i18n.__("Custom Formula"),
                              second: wp.i18n.__("eg: ({value}*2.5) for multiply a number to entered value, or {value} for an amount entered. Here value will be the value entered by customer")
                          },
                          order: 99,
                          conditions: [
                              {
                                  type: "field",
                                  field: "enablePrice",
                                  value: true
                              },
                              {
                                  type: "field",
                                  field: "pricingType",
                                  value: 'custom'
                              }
                          ]
                      },
                       {
                          item: 'price_label',
                          group: 'pricing',
                          render: 'text',
                          label: {
                              first: wp.i18n.__("Price label"),
                              second: wp.i18n.__("")
                          },
                          order: 99,
                          isMlEditable: true,
                          conditions: [
                              {
                                  type: "field",
                                  field: "enablePrice",
                                  value: true
                              },
                          ]
                      },
                      {
                          item: 'enableTax',
                          group: 'pricing',
                          render: 'toggle',
                          label: {first: wp.i18n.__('Enable Tax'), second: wp.i18n.__('')},
                          order: 99,
                          conditions: [
                              {
                                  type: "field",
                                  field: "enablePrice",
                                  value: true
                              },
                          ]
                      },
                      {
                          item: 'price_taxClass',
                          group: 'pricing',
                          render: { type: "select" },
                          options: taxClass_list,
                          label: {first: wp.i18n.__("Tax class")},
                          order: 99,
                          conditions: [
                              {
                                  type: "field",
                                  field: "enablePrice",
                                  value: true
                              },
                              {
                                  type: "field",
                                  field: "enableTax",
                                  value: true
                              }
                          ]
                      },
                    ],


        datepicker: defaultAttrs.concat(
            [
              {
                  item: 'pricingType',
                  group: 'pricing',
                  render: { type: "select" },
                  options: [
                      {value: 'fixed', label: wp.i18n.__('Fixed')},
                      {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
                      {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
                      {value: 'percentage_subtotal_extax', label: wp.i18n.__('Percentage of Cart subtotal Excluding Tax')},
                      //{value: 'custom', label: wp.i18n.__('Custom Formula')},
                  ],
                  order: 98,
                  label: wp.i18n.__("Pricing Type"),
                  conditions: [
                      {
                          type: "field",
                          field: "enablePrice",
                          value: true
                      }
                  ]

              },
              {
                item: 'wpml_sync',
                group: 'general',
                render: {
                    type: 'toggle'

                },
                label: {first: wp.i18n.__("Sync Options With Base Language?"), second: ''},
                conditions: [
                    {
                        type: "defaultLang",
                        value: false
                    }
                ],
                isMlEditable: true
            },
                {
                    item: 'mindate',
                    group: 'general',
                    render: {
                        type: 'text'
                    },
                    label: {
                        first: wp.i18n.__("Min Date"),
                        second: wp.i18n.__('The minimum selectable date. Specify a date in yyyy-mm-dd format, or number of days from today (e.g. 7). Add 0 for today.')
                    },
                    isMlEditable: true
                },
                {
                    item: 'maxdate',
                    group: 'general',
                    render: {
                        type: 'text'
                    },
                    label: {first: wp.i18n.__("Max Date"),
                        second: wp.i18n.__('The maximum selectable date. Specify a date in yyyy-mm-dd format, or number of days from today (e.g. 7). Add 0 for today.')},
                    isMlEditable: true
                },
                {
                    item: 'configuration',
                    group: 'general',
                    render: {
                        type: 'textarea'
                    },
                    label: wp.i18n.__("Configuration (JSON format)"),
                    isMlEditable: true
                },

            ]),
        datetimepicker: defaultAttrs.concat(
            [
              {
                  item: 'pricingType',
                  group: 'pricing',
                  render: { type: "select" },
                  options: [
                      {value: 'fixed', label: wp.i18n.__('Fixed')},
                      {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
                      {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
                      {value: 'percentage_subtotal_extax', label: wp.i18n.__('Percentage of Cart subtotal Excluding Tax')},
                      //{value: 'custom', label: wp.i18n.__('Custom Formula')},
                  ],
                  order: 98,
                  label: wp.i18n.__("Pricing Type"),
                  conditions: [
                      {
                          type: "field",
                          field: "enablePrice",
                          value: true
                      }
                  ]

              },
              {
                item: 'wpml_sync',
                group: 'general',
                render: {
                    type: 'toggle'

                },
                label: {first: wp.i18n.__("Sync Options With Base Language?"), second: ''},
                conditions: [
                    {
                        type: "defaultLang",
                        value: false
                    }
                ],
                isMlEditable: true
            },
                {
                    item: 'mindate',
                    group: 'general',
                    render: {
                        type: 'text'
                    },
                    label: {first: wp.i18n.__("Min Date"), second: wp.i18n.__('The minimum selectable date. Specify a date in yyyy-mm-dd format, or number of days from today (e.g. 7). Add 0 for today.')},
                    isMlEditable: true
                },
                {
                    item: 'maxdate',
                    group: 'general',
                    render: {
                        type: 'text'
                    },
                    label: {first: wp.i18n.__("Max Date"), second: wp.i18n.__('The maximum selectable date. Specify a date in yyyy-mm-dd format, or number of days from today (e.g. 7). Add 0 for today.')},
                    isMlEditable: true
                },
                {
                    item: 'configuration',
                    group: 'general',
                    render: {
                        type: 'textarea'
                    },
                    label: wp.i18n.__("Configuration (JSON format)"),
                    isMlEditable: true
                },

            ]),

            monthpicker: defaultAttrs.concat(
                [
                  {
                      item: 'pricingType',
                      group: 'pricing',
                      render: { type: "select" },
                      options: [
                          {value: 'fixed', label: wp.i18n.__('Fixed')},
                          {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
                          {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
                          {value: 'percentage_subtotal_extax', label: wp.i18n.__('Percentage of Cart subtotal Excluding Tax')},
                          //{value: 'custom', label: wp.i18n.__('Custom Formula')},
                      ],
                      order: 98,
                      label: wp.i18n.__("Pricing Type"),
                      conditions: [
                          {
                              type: "field",
                              field: "enablePrice",
                              value: true
                          }
                      ]
    
                  },
                  {
                    item: 'wpml_sync',
                    group: 'general',
                    render: {
                        type: 'toggle'
    
                    },
                    label: {first: wp.i18n.__("Sync Options With Base Language?"), second: ''},
                    conditions: [
                        {
                            type: "defaultLang",
                            value: false
                        }
                    ],
                    isMlEditable: true
                },
    
                ]),


                weekpicker: defaultAttrs.concat(
                    [
                        {
                            item: 'pricingType',
                            group: 'pricing',
                            render: { type: "select" },
                            options: [
                                {value: 'fixed', label: wp.i18n.__('Fixed')},
                                {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
                                {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
                                {value: 'percentage_subtotal_extax', label: wp.i18n.__('Percentage of Cart subtotal Excluding Tax')},
                                //{value: 'custom', label: wp.i18n.__('Custom Formula')},
                            ],
                            order: 98,
                            label: wp.i18n.__("Pricing Type"),
                            conditions: [
                                {
                                    type: "field",
                                    field: "enablePrice",
                                    value: true
                                }
                            ]
          
                        },
                        {
                          item: 'wpml_sync',
                          group: 'general',
                          render: {
                              type: 'toggle'
          
                          },
                          label: {first: wp.i18n.__("Sync Options With Base Language?"), second: ''},
                          conditions: [
                              {
                                  type: "defaultLang",
                                  value: false
                              }
                          ],
                          isMlEditable: true
                      },
                      ]),

        timepicker: defaultAttrs.concat(
            [
              {
                  item: 'pricingType',
                  group: 'pricing',
                  render: { type: "select" },
                  options: [
                      {value: 'fixed', label: wp.i18n.__('Fixed')},
                      {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
                      {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
                      {value: 'percentage_subtotal_extax', label: wp.i18n.__('Percentage of Cart subtotal Excluding Tax')},
                      //{value: 'custom', label: wp.i18n.__('Custom Formula')},
                  ],
                  order: 98,
                  label: wp.i18n.__("Pricing Type"),
                  conditions: [
                      {
                          type: "field",
                          field: "enablePrice",
                          value: true
                      }
                  ]

              },
              {
                item: 'wpml_sync',
                group: 'general',
                render: {
                    type: 'toggle'

                },
                label: {first: wp.i18n.__("Sync Options With Base Language?"), second: ''},
                conditions: [
                    {
                        type: "defaultLang",
                        value: false
                    }
                ],
                isMlEditable: true
            },
                {
                    item: 'configuration',
                    group: 'general',
                    render: {
                        type: 'textarea'
                    },
                    label: wp.i18n.__("Configuration (JSON format)"),
                    isMlEditable: true
                },

            ]),
        file: defaultAttrs.concat(
            [
              {
                  item: 'pricingType',
                  group: 'pricing',
                  render: { type: "select" },
                  options: [
                      {value: 'fixed', label: wp.i18n.__('Fixed')},
                      {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
                      {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
                      {value: 'percentage_subtotal_extax', label: wp.i18n.__('Percentage of Cart subtotal Excluding Tax')},
                      //{value: 'custom', label: wp.i18n.__('Custom Formula')},
                  ],
                  order: 98,
                  label: wp.i18n.__("Pricing Type"),
                  conditions: [
                      {
                          type: "field",
                          field: "enablePrice",
                          value: true
                      }
                  ]

              },
              {
                item: 'wpml_sync',
                group: 'general',
                render: {
                    type: 'toggle'

                },
                label: {first: wp.i18n.__("Sync Options With Base Language?"), second: ''},
                conditions: [
                    {
                        type: "defaultLang",
                        value: false
                    }
                ],
                isMlEditable: true
            },
                {
                    item: 'filetypes',
                    group: 'general',
                    render: {
                        type: 'text'
                    },
                    label: {first: wp.i18n.__("Allowed file types"), second: wp.i18n.__('Format: comma separated list. (e.g. png,pdf,doc) ')},
                    isMlEditable: true
                },
                {
                    item: 'minsize',
                    group: 'general',
                    render: {
                        type: 'text'
                    },
                    label: {first: wp.i18n.__("Min size"), second: wp.i18n.__('The minimum file size in MB. (e.g. 2) ')},
                    isMlEditable: true
                },
                {
                    item: 'maxsize',
                    group: 'general',
                    render: {
                        type: 'text'
                    },
                    label: {first: wp.i18n.__("Max size"), second: wp.i18n.__('The maximum file size in MB. (e.g. 2) ')},
                    isMlEditable: true
                },

            ]),
            

        textarea: defaultAttrs.concat(
            [
              {
                  item: 'pricingType',
                  group: 'pricing',
                  render: { type: "select" },
                  options: [
                      {value: 'fixed', label: wp.i18n.__('Fixed')},
                      {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
                      {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
                      {value: 'percentage_subtotal_extax', label: wp.i18n.__('Percentage of Cart subtotal Excluding Tax')},
                      {value: 'custom', label: wp.i18n.__('Custom Formula')},
                  ],
                  order: 98,
                  label: wp.i18n.__("Pricing Type"),
                  conditions: [
                      {
                          type: "field",
                          field: "enablePrice",
                          value: true
                      }
                  ]

              },
                // {item: 'disable_manual_input', group: 'general', render: 'text'},
                {
                    item: 'disable_manual_input',
                    group: 'general',
                    render: 'toggle',
                    label: {first: wp.i18n.__('Read-only')}
                },
                {
                    item: 'allowed_char_regex',
                    group: 'advanced',
                    render: 'text',
                    label: {first: wp.i18n.__('Allowed Characters(Regex)'), second: wp.i18n.__('Use regular expression')}
                },
                {
                    item: 'allowed_char_errmsg',
                    group: 'advanced',
                    render: 'text',
                    label: {first: wp.i18n.__('Error message'), second: wp.i18n.__('Only for Allowed Characters validation')}
                },
                {item: 'maxlength', group: 'advanced', render: 'number', label: wp.i18n.__('Max Length')},
                {item: 'rows', group: 'advanced', render: 'number', label: wp.i18n.__('Rows')},
            ]
        ),

    placeselector: defaultAttrs.concat(
        [
          // {
          //     item: 'instructions',
          //     group: 'general',
          //     render: {
          //         type: 'instructions',
          //         message: wp.i18n.__("You must setup Google Map API keys in plugin settings at (Settings>>Checkout Fields>>General settings) in order to work this place selector")
          //     },
          //     label: '',
          //     order: 10,
          // },
          {
                item: 'showmap',
                group: 'general',
                render: {
                    type: 'toggle'

                },
                label: wp.i18n.__("Show Google Map")

            },
            {
                item: 'showaddfields',
                group: 'general',
                render: {
                    type: 'toggle'

                },
                label: wp.i18n.__("Show Address fields")

            },
            {
                item: 'map_height',
                group: 'general',
                render: {
                    type: 'text',

                },
                label: wp.i18n.__("Map Height (in px)")

            },
          {
              item: 'pricingType',
              group: 'pricing',
              render: { type: "select" },
              options: [
                  {value: 'fixed', label: wp.i18n.__('Fixed')},
                  {value: 'percentage_content_total', label: wp.i18n.__('Percentage of Cart contents total')},
                  {value: 'percentage_subtotal', label: wp.i18n.__('Percentage of Cart subtotal')},
                  {value: 'percentage_subtotal_extax', label: wp.i18n.__('Percentage of Cart subtotal Excluding Tax')},
                  //{value: 'custom', label: wp.i18n.__('Custom Formula')},
              ],
              order: 98,
              label: wp.i18n.__("Pricing Type"),
              conditions: [
                  {
                      type: "field",
                      field: "enablePrice",
                      value: true
                  }
              ]

          },
          {
            item: 'wpml_sync',
            group: 'general',
            render: {
                type: 'toggle'

            },
            label: {first: wp.i18n.__("Sync Options With Base Language?"), second: ''},
            conditions: [
                {
                    type: "defaultLang",
                    value: false
                }
            ],
            isMlEditable: true
        },
        ]),

    }

    typeAttrsMap.select = typeAttrsMap.select.filter((e => e.item !== 'default'));
    typeAttrsMap.checkboxGroup = typeAttrsMap.checkboxGroup.filter((e => e.item !== 'default'));
    typeAttrsMap.textarea = typeAttrsMap.textarea.map((e => (e.item === 'default' && {...e, render: "textarea"}) || e));
    typeAttrsMap.radio = typeAttrsMap.checkboxGroup;

    typeAttrsMap.checkboxGroup = typeAttrsMap.checkboxGroup.concat([
      {item: 'min_options', group: 'advanced', render: 'number', label: {first: wp.i18n.__("Minimum fields to select"), second: 'Leave blank for no restriction'}, },
      {item: 'max_options', group: 'advanced', render: 'number', label: {first: wp.i18n.__("Maximum fields can select"), second: 'Leave blank for no restriction'}, },
    ]);


    typeAttrsMap.imageGroup = typeAttrsMap.checkboxGroup.concat(
      [
          {
              item: 'multiple',
              group: 'general',
              render: 'toggle',
              label: wp.i18n.__("Allow Multiple Selections"),
          },
          {
              item: 'disp_size_img',
              group: 'general',
              render: {
                  type: 'number'
              },
              label: {
                  first: wp.i18n.__("Image display size in pixel"),
                  second: wp.i18n.__("(Leave blank to use default image size)")
              }

          },
          {
              item: 'disp_type',
              group: 'general',
              render: { type: "select" },
              options: [
                  {value: 'square', label: wp.i18n.__('Square')},
                  {value: 'circle', label: wp.i18n.__('Circle')},
                  {value: 'squircle', label: wp.i18n.__('Squircle')},
              ],
              label: {
                  first: wp.i18n.__("Box display type"),
                  second: wp.i18n.__("")
              }

          },
          {
              item: 'img_selection_type',
              group: 'general',
              render: { type: "select" },
              options: [
                  {value: 'outline', label: wp.i18n.__('Outline')},
                  {value: 'shadow', label: wp.i18n.__('Shadow')},
                  {value: 'tick', label: wp.i18n.__('Tick')},
                  {value: 'tick-shadow', label: wp.i18n.__('Tick with Shadow')},
              ],
              label: {
                  first: wp.i18n.__("Image selection type"),
                  second: wp.i18n.__("")
              }

          },
          // disp_size_img img_preview enable_popup disp_type img_selection_type
      ]);


      typeAttrsMap.colorGroup = typeAttrsMap.checkboxGroup.concat(
        [
            {
                item: 'multiple',
                group: 'general',
                render: 'toggle',
                label: wp.i18n.__("Allow Multiple Selections"),
            },
            {
                item: 'disp_size_img',
                group: 'general',
                render: {
                    type: 'number'
                },
                label: {
                    first: wp.i18n.__("Color display size in pixel"),
                    second: wp.i18n.__("(Leave blank to use default size)")
                }

            },
            {
                item: 'disp_type',
                group: 'general',
                render: { type: "select" },
                options: [
                    {value: 'square', label: wp.i18n.__('Square')},
                    {value: 'circle', label: wp.i18n.__('Circle')},
                    {value: 'squircle', label: wp.i18n.__('Squircle')},
                ],
                label: {
                    first: wp.i18n.__("Box display type"),
                    second: wp.i18n.__("")
                }

            },
            {
                item: 'img_selection_type',
                group: 'general',
                render: { type: "select" },
                options: [
                    {value: 'outline', label: wp.i18n.__('Border')},
                    // {value: 'shadow', label: wp.i18n.__('Shadow')},
                    {value: 'tick', label: wp.i18n.__('Tick')},
                    {value: 'tick-shadow', label: wp.i18n.__('Tick with Border')},
                ],
                label: {
                    first: wp.i18n.__("Image selection type"),
                    second: wp.i18n.__("")
                }

            },
        ]);


    const typeAttrs = (typeAttrsMap[type] || defaultAttrs).sort((a, b) => {
        if (typeof a.order === 'undefined') {
            a.order = 10;
        }
        if (typeof b.order === 'undefined') {
            b.order = 10;
        }
        if (a.order < b.order) {
            return -1;
        }
        if (a.order > b.order) {
            return 1;
        }
        return 0;
    });


    return typeAttrs || defaultAttrs
}

export const optionsDefault = (type, v = false) => {
    const t = {
        select: {"label": "Option - " + v, "value": "Option - " + v, "price": "", "selected": false},
        checkboxGroup: {"label": "", "value": "", "price": "", "selected": false},
        // multiselect: {"label": "Option - " + v, "value": "Option - " + v, "price": "", "selected": false},

        imageGroup: {"label": "Option - " + v, "value": "Option - " + v, "price": "", "selected": false, "image": window.awcfe_object.default_image_url, "thumb": window.awcfe_object.default_image_url},

        colorGroup: {label: "Option - " + v, value: "Option - " + v, selected: false, color: "#c3d6f1"},
        // imageGroup: {
        //     label: `Option - ${  v}`, value: `Option - ${  v}`, selected: false,
        //     image: window.awcfe_object.default_image_url,
        //     thumb: window.awcfe_object.default_image_url
        // },
    };

    const t2 = {
        select: {"label": "", "value": "", "price": "", "selected": false},
        // checkbox: {"label": "", "value": "", "price": "", "selected": false},
        checkboxGroup: {"label": "", "value": "", "price": "", "selected": false},
        radio: {"label": "", "value": "", "price": "", "selected": false},
        multiselect: {"label": "", "value": "", "price": "", "selected": false},

        imageGroup: {"label": "", "value": "", "price": "", "selected": false, "image": window.awcfe_object.default_image_url, "thumb": window.awcfe_object.default_image_url},

        colorGroup: {label: "", value: "", selected: false, color: "#c3d6f1"},

        // imageGroup: {
        //     label: "", value: "", selected: false,
        //     image: window.awcfe_object.default_image_url,
        //     thumb: window.awcfe_object.default_image_url
        // }

    };
    return v ? t[type] : t2[type];
}
export const fieldDefinitions = (type, section) => {
    const id = newElementId();
    const defaultValues = {
        "active": true,
        "custom": true,
        "col": 6,
        "relations": false,
        "cl_rule": "show",
        "enableCl": false,
        "price": "",
        "enablePrice": false,
        "show_in_email": true,
        "show_in_order_page": true,
    }
    const fieldDefinitions = {
        select: {
            "type": "select",
            "required": false,
            "elementId": `select-${id}`,
            "label": "Select Field",
            // "enablePrice": false,
            // "price": "",
            // "name": `textarea-${id}`,
            // "cl_rule": "show",
            // "col": 6,
            "priceOptions": "",
            "pricingType": "",
            "name": `select-${  id}`,
            "options": [1, 2, 3].map((v) => optionsDefault('select', v)),

        },
        text: {
            "type": "text",
            "subtype": "text",
            "required": false,
            "elementId": `text-${id}`,
            "label": "Text Field",
            "enablePrice": false,
            "price": "",
            "name": `${section}_text_field`,
            "cl_rule": "show",
            "col": 6,
            "default": "",
            "enableCl": false,
            "relations": false
        },
        url: {
            "type": "url",
            "required": false,
            "elementId": `url-${id}`,
            "label": "URL Field",
            "enablePrice": false,
            "price": "",
            "name": `${section}_url_field`,
            "cl_rule": "show",
            "col": 6,
            "default": "",
            "enableCl": false,
            "relations": false
        },
        numberfield: {
            "type": "numberfield",
            "required": false,
            "elementId": `number-${id}`,
            "label": "Number Field",
            "enablePrice": false,
            "price": "",
            "name": `${section}_number_field`,
            "cl_rule": "show",
            "col": 6,
            "default": "",
            "enableCl": false,
            "relations": false
        },
        textarea: {
            "type": "textarea",
            "required": false,
            "elementId": `textarea-${id}`,
            "label": "Textarea Field",
            "enablePrice": false,
            "price": "",
            "name": `textarea-${id}`,
            "cl_rule": "show",
            "col": 6,
            "default": "",
            "rows": 2,
            "relations": false
        },
        
        checkboxGroup: {
            "type": "checkboxGroup",
            "required": false,
            "elementId": `checkbox-${id}`,
            "label": "Checkbox group Field",
            "priceOptions": "",
            "pricingType": "",
            "name": `checkbox-${  id}`,
            "options": [1, 2, 3].map((v) => optionsDefault('select', v)),
        },
        checkbox: {
            "type": "checkbox",
            "default": "Yes",
            "required": false,
            "elementId": `check-box-${id}`,
            "label": "Checkbox Field",
            "priceOptions": "",
            "pricingType": "",
            "name": `checkbox-${id}`,

        },
        toggleSwitch: {
            "type": "toggleSwitch",
            "default": "Yes",
            "required": false,
            "elementId": `toggleswitch-${id}`,
            "label": "Toggle Switch Field",
            "priceOptions": "",
            "pricingType": "",
            "name": `toggleSwitch-${id}`,
            "makeinline":false,
        },
        imageGroup: {
            "type": "imageGroup",
            "required": false,
            "elementId": `imagegroup-${id}`,
            "label": "Image Field",
            "name": `image-${id}`,
            //"enable_popup":"no",
            "multiple":false,
            "makeinline":true,
            "img_selection_type":'shadow',
            "disp_type":'square',
            "options": [1, 2, 3].map((v) => optionsDefault('imageGroup', v)),
        },
        colorGroup: {
            "type": "colorGroup",
            "required": false,
            "elementId": `colorgroup-${id}`,
            "label": "Color Field",
            "name": `colorGroup-${id}`,
            //"enable_popup":"no",
            "multiple":false,
            "makeinline":true,
            "img_selection_type":'tick-shadow',
            "disp_type":'square',
            "disp_size_img":60,
            "options": [1, 2, 3].map((v) => optionsDefault('colorGroup', v)),
        },
        multiselect: {
            "type": "multiselect",
            "required": false,
            "elementId": `multiselect-${id}`,
            "label": "Multi Select Field",
            "priceOptions": "",
            "pricingType": "",
            "name": `multiselect-${  id}`,
            "options": [1, 2, 3].map((v) => optionsDefault('select', v)),

        },
        datepicker: {
            "type": "datepicker",
            "required": false,
            "elementId": `date-${id}`,
            "label": "Date Field",
            "priceOptions": "",
            "pricingType": "",
            "name": `date-${  id}`,
            "mindate": '',
            "maxdate": '',
        },
        datetimepicker: {
            "type": "datetimepicker",
            "required": false,
            "elementId": `datetime-${id}`,
            "label": "Date Time Field",
            "priceOptions": "",
            "pricingType": "",
            "name": `datetime-${  id}`,
            "mindate": '',
            "maxdate": '',
        },

        monthpicker: {
            "type": "monthpicker",
            "required": false,
            "elementId": `month-${id}`,
            "label": "Month Field",
            "priceOptions": "",
            "pricingType": "",
            "name": `month-${id}`,
        },

        weekpicker: {
           "type": "weekpicker",
            "required": false,
            "elementId": `week-${id}`,
            "label": "Week Field",
            "priceOptions": "",
            "pricingType": "",
            "name": `week-${id}`,
        },

        timepicker: {
            "type": "timepicker",
            "required": false,
            "elementId": `time-${id}`,
            "label": "Time Field",
            "priceOptions": "",
            "pricingType": "",
            "name": `time-${  id}`,
        },
        colorpicker: {
            "type": "colorpicker",
            "required": false,
            "elementId": `color-${id}`,
            "label": "Color picker",
            "priceOptions": "",
            "pricingType": "",
            "name": `color-${  id}`,
        },
        file: {
            "type": "file",
            "required": false,
            "elementId": `file-${id}`,
            "label": "File upload Field",
            "priceOptions": "",
            "pricingType": "",
            "name": `file-${  id}`,
        },
        radio: {
            "type": "radio",
            "required": false,
            "elementId": `radio-${id}`,
            "label": "Radio Field",
            "priceOptions": "",
            "pricingType": "",
            "name": `radio-${  id}`,
            "options": [1, 2, 3].map((v) => optionsDefault('select', v)),

        },
        paragraph: {
            "type": "paragraph",
            "required": false,
            "elementId": `paragraph-${id}`,
            "label": "Paragraph Field",
            "subtype": "p",
            "show_in_email": false,
            "show_in_order_page": false,

        },
        htmlf: {
            "type": "htmlf",
            "required": false,
            "value" : "",
            "elementId": `htmlf-${id}`,
            "label": "HTML Field",
            "name": `htmlf-${id}`,
            "show_in_email": false,
            "show_in_order_page": false,
            "cl_rule": "show",
            "enableCl": false,
        },
        header: {
            "type": "header",
            "required": false,
            "elementId": `header-${id}`,
            "label": "Header Field",
            "subtype": "h1",
            "show_in_email": false,
            "show_in_order_page": false,
            "cl_rule": "show",
            "enableCl": false,
        },
        placeselector: {
            "type": "placeselector",
            "required": false,
            "elementId": `placeselector-${id}`,
            "label": "Google Place Selector",
            "priceOptions": "",
            "pricingType": "",
            "name": `place-${  id}`,
            "showmap": true,
            "showaddfields": true,
            "map_height": '300',
        },
    }


    let result = {...defaultValues, ...(fieldDefinitions[type] || fieldDefinitions.text),};
    if (typeof result.name !== 'undefined') {
        result.name = section + "_" + result.label.toLowerCase()
            .replace(/[^\w ]+/g, '')
            .replace(/ +/g, '_');
    }
    return {...result};
}

export const fieldTypes = [
    {
        extra: {},
        fields: [
           
            {'name': 'Text', 'icon': 'textbox.svg', 'key': 'text'},
            {'name': 'Number', 'icon': 'Number.svg', 'key': 'numberfield'},
            {'name': 'Textarea', 'icon': 'textarea.svg', 'key': 'textarea'},
            {'name': 'Radio', 'icon': 'radio.svg', 'key': 'radio'},
            {'name': 'Select', 'icon': 'select.svg', 'key': 'select'},
            {'name': 'Multi-select', 'icon': 'Multi-select.svg', 'key': 'multiselect'},
            {'name': 'Checkbox', 'icon': 'checkbox.svg', 'key': 'checkbox'},
            {'name': 'Checkbox Group', 'icon': 'checkgroup.svg', 'key': 'checkboxGroup'},
            {'name': 'Header', 'icon': 'header.svg', 'key': 'header'},
            {'name': 'Paragraph', 'icon': 'paragraph.svg', 'key': 'paragraph'},
            {'name': 'Html', 'icon': 'Html.svg', 'key': 'htmlf'},
            {'name': 'Date', 'icon': 'Date.svg', 'key': 'datepicker'},
            {'name': 'Time', 'icon': 'Time.svg', 'key': 'timepicker'},
            {'name': 'Date Time', 'icon': 'Date-time.svg', 'key': 'datetimepicker'},
            {'name': 'Month', 'icon': 'month.svg', 'key': 'monthpicker'},
            {'name': 'Week', 'icon': 'week.svg', 'key': 'weekpicker'},

            {'name': 'Color Picker', 'icon': 'Color-picker.svg', 'key': 'colorpicker'},
            {'name': 'File Upload', 'icon': 'upload.svg', 'key': 'file'},
            {'name': 'Google Place Selector', 'icon': 'map-pin.svg', 'key': 'placeselector'},
            {'name': 'Image Group', 'icon': 'ImageGroup.svg', 'key': 'imageGroup'},
            {'name': 'Color Group', 'icon': 'color-group.svg', 'key': 'colorGroup'},
            {'name': 'Toggle Switch', 'icon': 'switch.svg', 'key': 'toggleSwitch'},
            {'name': 'URL', 'icon': 'url.svg', 'key': 'url'},
        ]
    }
]


export const fieldCopy = (field, sectionId) => {
    if ( Array.isArray(field) == false ) {
        const id = newElementId()
        let newFiled = {}
        let schema = defaultFieldAttrs(field.type)

        schema.forEach((e) => {
            if (e.item === "name") {
                newFiled.name = `${field.name}_2`;
                newFiled.nameAutoUpdate = true
            } else {
                newFiled[e.item] = field[e.item];
            }
        })
        newFiled.col = field.col;
        newFiled.type = field.type;
        newFiled.cl_rule = field.cl_rule;
        newFiled.custom = true;
        newFiled.elementId = `${field.type}-${id}`;
        newFiled.bindingKey = "";
        return newFiled;
    } else if ( Array.isArray(field) == true ) {

        let secArr = [];
        field.forEach((i) => {

            const id = newElementId()
            let newFiled = {}
            let schema = defaultFieldAttrs(i.type)
            let nwname = '';
            schema.forEach((e) => {

                if (e.item === "name") {
                    if(i.label){
                        nwname = (i.label.replace(/\//g, '')).replace(/\s+/g, '_').toLowerCase();
                    } else {
                        nwname = i.name;
                    }
                    newFiled.name = `${sectionId}_${nwname}`;
                    newFiled.nameAutoUpdate = true
                } else {
                    newFiled[e.item] = i[e.item];
                }
            })
            newFiled.col = i.col;
            newFiled.type = i.type;
            newFiled.cl_rule = i.cl_rule;
            newFiled.custom = true;
            newFiled.elementId = `${i.type}-${id}`;
            newFiled.bindingKey = "";
            secArr.push(newFiled);
            // return newFiled;
        })
        return secArr;
    }

}


export const sectionCopy = (section, sectionId) => {

    let newSection = {};
    newSection.extra = { 'key': sectionId, 'section_id': sectionId, 'name': section.extra.name, 'status': section.extra.status, 'enableSec': section.extra.enableSec, 'custom': true, 'sec_Order': section.extra.sec_Order, 'sec_Position': section.extra.sec_Position, 'sec_Class': section.extra.sec_Class, 'enableCl': section.extra.enableCl, 'cl_rule': section.extra.cl_rule, 'relations': section.extra.relations  };
    newSection.fields = {};

     newSection.fields = section.fields.map(
        e => {
            return fieldCopy(e, sectionId);
        }
    )

    return {...newSection}
};


export const checkIsReadOnly = (field, e) => {

    if (field.type === 'htmlf') {
        if (e.item === 'show_in_email' || e.item === 'show_in_order_page') {
          return true;
        }
      }

  if( field.subtype == 'hidden' ){
    if( e.item == 'placeholder' || e.item == 'required' || e.item == 'disable_manual_input' || e.item == 'allowed_char_regex' || e.item == 'allowed_char_errmsg' || e.item == 'maxlength' || e.item == 'enableCl' || e.item == 'enablePrice' ){
      return true;
    }
  }
  if( field.type == 'country' ){
    if( e.item == 'active'){
     // return true;
    }
  }
  if( field.type == 'file' ){
    if( e.item == 'default'){
      return true;
    }
  }
  
  if( field.type == 'imageGroup' || field.type == 'colorGroup' || field.type == 'colorpicker' || field.type == 'checkboxGroup' || field.type == 'radio' ){
    if( e.item == 'placeholder' ){
      return true;
    }
  }
  if( field.type == 'country' || field.type == 'state' ){
    if( e.item == 'placeholder' || e.item == 'default' || e.item == 'enablePrice' ){
      return true;
    }
  }
    if (!field.custom) {
        if (e.item === 'name' || e.item === 'show_in_email' || e.item === 'show_in_order_page') {
            return true;
        }
    }
    if (window.awcfe_object.isMlActive && window.awcfe_object.ml.isDefault === false) {
        if (e.item === 'options' && field.wpml_sync === true) {
            return true;
        }
        return typeof e.isMlEditable !== 'undefined' && e.isMlEditable ? false : true
    }
    return false;
}

export const checkIsReadOnlySection = (field, e) => {

    if (!field.custom) {
        // if (e.item === 'sec_Position' || e.item === 'sec_Order' || e.item === 'sec_Show_in_order_page' || e.item === 'sec_Show_in_email' || e.item === 'enableSec' || e.item === 'sec_Class' ) {
        if (e.item === 'sec_Position' || e.item === 'sec_Order' || e.item === 'enableSec' || e.item === 'sec_Class' || e.item === 'enableCl'  ) {
            return true;
        }
    }
    return false;
}
